const setVinData = function({ commit }, data) {
  commit('SET_VIN_IDENTIFICATION_DATA', data);
  return data;
};

const setMileageData = function({ commit }, data) {
  commit('SET_VEHICLE_MILEAGE', data);
  return data;
};

const setHsnTsnData = function({ commit }, formData) {
  commit('SET_HSN_TSN_DATA', formData);
};

export default {
  setMileageData,
  setVinData,
  setHsnTsnData
}
